import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { payments as paymentsApi } from 'redux/modules/api'
import { modal, notification, logError } from 'redux/modules/app'

function decorator(config = {}) {
  const enhance = compose(
    connect(
      ({ api }) => ({
        local: {},
        payments: api.payments
      }),
      { ...paymentsApi, modal, notification, logError }
    )
  )

  return ComposedComponent => {
    class Payments extends Component {
      static propTypes = {
        payments: PropTypes.object.isRequired,
        paymentsFilter: PropTypes.string,
        resetPaymentLinkExpiration: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        forOrganization: PropTypes.bool,
        getPaymentsWaiting: PropTypes.func.isRequired,
        getPaymentsExpired: PropTypes.func.isRequired,
        modal: PropTypes.func
      }

      static defaultProps = {
        params: {}
      }

      componentDidMount() {
        this.handleFetch()
      }

      componentWillReceiveProps(nextProps) {
        const { payments } = this.props
        const { filter, limit, offset, sort } = nextProps.payments.waiting
        const {
          filter: filterExpired,
          limit: limitExpired,
          offset: offsetExpired,
          sort: sortExpired
        } = nextProps.payments.expired

        if (
          config.waiting &&
          (payments.waiting.filter !== filter ||
            payments.waiting.limit !== limit ||
            payments.waiting.offset !== offset ||
            payments.waiting.sort !== sort)
        ) {
          this.handleGetPaymentsWaiting(
            nextProps.payments.waiting,
            this.handleGetBaseFilter()
          )
        }

        if (
          config.expired &&
          (payments.expired.filter !== filterExpired ||
            payments.expired.limit !== limitExpired ||
            payments.expired.offset !== offsetExpired ||
            payments.expired.sort !== sortExpired)
        ) {
          this.handleGetPaymentsExpired(
            nextProps.payments.expired,
            this.handleGetBaseFilter()
          )
        }
      }

      handleGetBaseFilter = () => {
        const { paymentsFilter, params } = this.props

        switch (paymentsFilter || config.filter) {
          case 'organizationPayments':
            return `participantRegistration.organizationId=${params.id}`
          default:
            return ''
        }
      }

      handleGetPaymentsWaiting = (payments, baseFilter) => {
        const { forOrganization, params } = this.props
        let queryParams = {}

        if (forOrganization) {
          queryParams = {
            filterForOrganizationId: params.id
          }
        }

        this.props.getPaymentsWaiting(payments, baseFilter, queryParams)
      }

      handleGetPaymentsExpired = (payments, baseFilter) => {
        const { forOrganization, params } = this.props
        let queryParams = {}

        if (forOrganization) {
          queryParams = {
            filterForOrganizationId: params.id
          }
        }

        this.props.getPaymentsExpired(payments, baseFilter, queryParams)
      }

      handleResetPaymentLink = id => {
        this.props
          .resetPaymentLinkExpiration(id)
          .then(this.handleResetLinkSuccess)
          .catch(this.handleError)
      }

      handleResetLinkSuccess = () => {
        this.props.notification('Payment link has been reset', {
          status: 'success',
          intlKey: 'notifications.payment_link_has_been_reset'
        })
        this.handleFetch()
        this.props.modal(null)
      }

      handleFetch = () => {
        const { payments } = this.props

        if (config.waiting) {
          this.handleGetPaymentsWaiting(
            payments.waiting,
            this.handleGetBaseFilter()
          )
        }

        if (config.expired) {
          this.handleGetPaymentsExpired(
            payments.expired,
            this.handleGetBaseFilter()
          )
        }
      }

      handleError = err => {
        console.log('error', err.body && err.body.userMessage)
        this.props.logError(err)
      }

      render() {
        const params = {
          ...this.props,
          local: undefined
        }

        return (
          <ComposedComponent
            {...params}
            onResetPaymentLink={this.handleResetPaymentLink}
          />
        )
      }
    }
    return enhance(Payments)
  }
}

export default decorator
